import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { BreadcrumbService } from '../services/breadcrumb.service';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbsConstructor implements CanActivate {
  constructor(private breadCrumbsService: BreadcrumbService) {}

  canActivate(route: ActivatedRouteSnapshot) {
    this.breadCrumbsService.setBreadcrumbs(route.data['breadcrumbs']);    
    return true;
  }
}
